import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { map, Observable } from 'rxjs';

import { FrontendModalService } from '@tablesready/frontend-modal';
import { InfoModalComponent } from '@tablesready/common-ui';
import {
  BillingVisibility,
  FrontendPaidFeatureService,
} from '@tablesready/frontend-paid-feature-alert';

@Injectable({ providedIn: 'root' })
export class PartiesUsageService {
  constructor(
    private readonly router: Router,
    private readonly paidService: FrontendPaidFeatureService,
    private readonly modalController: FrontendModalService,
  ) {}

  partiesLimitReached(
    partiesLimit: number,
    isLocationManager: boolean,
  ): Observable<any> {
    let message = 'You have reached the limit of parties';
    let displayButton = false;

    if (
      this.paidService.billingsVisibility === BillingVisibility.FULL ||
      this.paidService.billingsVisibility === BillingVisibility.LINKS_ONLY_ON_MOBILE
    ) {
      message = `You have added ${partiesLimit} out of your plan’s allowed ${partiesLimit} parties for this month.`;
      displayButton = true;
    }

    return this.modalController.create<InfoModalComponent, boolean>(
      InfoModalComponent,
      {
        message,
        displayButton,
        buttonText: isLocationManager ? 'Click here to upgrade your plan' : 'Confirm',
      },
    ).pipe(map(res => {
      if (res && isLocationManager) {
        this.router.navigateByUrl('/settings/location/billing');
      }

      return null;
    }));
  }
}
